import { ReactElement } from 'react';
import { AiOutlineArrowRight, AiOutlineArrowLeft } from 'react-icons/ai';
import { FiUser } from 'react-icons/fi';
import { Flex, Text, Link, Icon } from '@chakra-ui/react';
import { useForm, SubmitHandler } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import NextLink from 'next/link';

import {
  InputsSecondStep,
  SecondStepRegistrationSchema,
} from 'lib/schemas/candidates/secondStepRegistration';
import Button from 'components/atoms/button';
import Field from 'components/molecules/form/field';
import PasswordField from 'components/molecules/form/passwordField';

export interface FormSecondStepProps {
  submitSecondStep: SubmitHandler<InputsSecondStep>;
  changeFormStep: (step: number) => void;
}

const FormSecondStep = ({
  submitSecondStep,
  changeFormStep,
}: FormSecondStepProps): ReactElement => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<InputsSecondStep>({
    resolver: yupResolver(SecondStepRegistrationSchema),
  });

  return (
    <form onSubmit={handleSubmit(submitSecondStep)}>
      <Flex alignItems='flex-end' flexWrap='wrap'>
        <Field
          height='50px'
          label='Nome completo (mín. 5 caracteres)'
          placeholder='Digite o seu nome completo'
          leftIcon={FiUser}
          {...register('fullName', { required: true })}
          errors={errors}
          isRequired
        />

        <PasswordField
          height='50px'
          mt={4}
          label='Senha (mín. 8 caracteres)'
          placeholder='Digite a sua senha'
          {...register('password')}
          errors={errors}
        />

        <PasswordField
          height='50px'
          mt={4}
          label='Confirmar senha'
          placeholder='Digite novamente a senha'
          {...register('repeatPassword')}
          errors={errors}
        />

        <Button mt={4} w='100%' type='submit' rightIcon={AiOutlineArrowRight}>
          Criar meu perfil agora
        </Button>
      </Flex>

      <Flex justify='space-between' py={4}>
        <Text
          color='text.100'
          cursor='pointer'
          onClick={() => changeFormStep(1)}
        >
          <Icon as={AiOutlineArrowLeft} /> Voltar
        </Text>

        <Text color='text.100'>
          Já possui conta?{' '}
          <Link as={NextLink} color='primary.500' href='/'>
            Faça Login
          </Link>
        </Text>
      </Flex>
    </form>
  );
};

export default FormSecondStep;
